// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Group, Paper, Title } from '@mantine/core';
import type { JSX, ReactNode } from 'react';

interface FormCardProps {
  title: string;
  titleOrder?: 1 | 2 | 3 | 4 | 5 | 6;
  action?: ReactNode;
  children?: ReactNode;
  isEditing?: boolean;
}

export function FormCard({ title, titleOrder = 2, action, children, isEditing }: FormCardProps): JSX.Element {
  return (
    <Paper
      p="xl"
      radius="md"
      shadow="sm"
      withBorder
      style={{
        borderColor: isEditing ? 'var(--mantine-primary-color-filled)' : undefined,
        borderWidth: isEditing ? 2 : undefined,
        transition: 'border-color 0.2s, border-width 0.2s',
      }}
    >
      <Group justify="space-between" mb="md">
        <Title order={titleOrder}>{title}</Title>
        {action}
      </Group>
      {children}
    </Paper>
  );
}
